import { Link } from "components/elements";
import { TableRowColumn, TableSubRow } from "components/layout";
import { TiVoAppProvider, TiVoAppVariant } from "hooks/tivoApps";
import { formatDate } from "utils/date";
import { pathToUrl } from "utils/url";

import { TEXTS } from "../AppsList/constants";
import { DEFAULT_PATHS, PATHS } from "../constants";
import { TiVoAppRowVariantMenu } from "./TiVoAppRowVariantMenu";
import styles from "./TiVoAppSubRow.scss";

interface TiVoAppSubRowProps {
  provider: TiVoAppProvider;
  variant: TiVoAppVariant;
}

function getStatus({ status = [] }: TiVoAppVariant) {
  return (
    (status.length && status.join(", ").toUpperCase()) || TEXTS.EMPTY_STATUS
  );
}

export function TiVoAppSubRow({ provider, variant }: TiVoAppSubRowProps) {
  return (
    <TableSubRow key={variant.id}>
      <TableRowColumn className={styles.variantName}>
        <Link
          to={pathToUrl(PATHS.detailsVariant, {
            id: provider.id,
            variantId: variant.id,
            tabId: DEFAULT_PATHS.VARIANT_DETAILS,
          })}
        >
          {variant.label || TEXTS.EMPTY_LABEL}
        </Link>
      </TableRowColumn>
      <TableRowColumn className={styles.date}>
        {variant.creationDate && formatDate(new Date(variant.creationDate))}
      </TableRowColumn>
      <TableRowColumn>{getStatus(variant)}</TableRowColumn>
      <TableRowColumn className={styles.menu}>
        <TiVoAppRowVariantMenu id={provider.id} variantId={variant.id} />
      </TableRowColumn>
    </TableSubRow>
  );
}
